
define('ldsh!modules/currency/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Currency</h1>\n<dl>\n  \n\t <dd>\n   <span name="name"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

